import { render, staticRenderFns } from "./NoticeMail.vue?vue&type=template&id=65e1691a&scoped=true&"
import script from "./NoticeMail.vue?vue&type=script&lang=js&"
export * from "./NoticeMail.vue?vue&type=script&lang=js&"
import style0 from "./NoticeMail.vue?vue&type=style&index=0&id=65e1691a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e1691a",
  null
  
)

export default component.exports